import api from "@/api";

export default {
  state: {
    potentialPolicies: [],
    potentialPolicyToEdit: {},
  },
  getters: {
    potentialPolicies: (state) => state.potentialPolicies,
    potentialPolicyToEdit: (state) => state.potentialPolicyToEdit,
  },
  mutations: {
    setPotentialPolicies: (state, data) => {
      state.potentialPolicies = data;
    },

    setPotentialPolicyToEdit: (state, data) => {
      state.potentialPolicyToEdit = data;
    },
  },
  actions: {
    getPotentialPolicies: async ({ commit }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/potential-policies"
        );
        const { data } = response.data;
        commit("setPotentialPolicies", data);
      } catch (err) {
        console.error(err);
      }
    },

    async createPotentialPolicy({ commit }, {
      customerId,
      agentId,
      date,
      branchCategoryId,
      priorityId,
      text,
      teamId,
    }) {
      try {
        return await api({ requiresAuth: true }).post("/v1/potential-policies", {
          customer_id: customerId,
          agent_id: agentId,
          date,
          branch_category_id: branchCategoryId,
          priority_id: priorityId,
          text,
          team_id: teamId,
        });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || "Something went wrong.",
        }, { root: true });
        throw err;
      }
    },

    async updatePotentialPolicyAgent({ commit }, { potentialPolicyId, agentId }) {
      try {
        await api({
          requiresAuth: true,
        }).patch(`/v1/potential-policies/${potentialPolicyId}/agents`, {
          agent_id: agentId,
        });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || "Something went wrong.",
        }, { root: true });
        throw err;
      }
    },

    async updatePotentialPolicyText({ commit }, { potentialPolicyId, text }) {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/potential-policies/${potentialPolicyId}/texts`,
          {
            text,
          }
        );
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || "Something went wrong.",
        }, { root: true });
        throw err;
      }
    },

    async deletePotentialPolicy({ commit }, potentialPolicyId) {
      try {
        await api({ requiresAuth: true }).delete(
          `/v1/potential-policies/${potentialPolicyId}`
        );
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || "Something went wrong.",
        }, { root: true });
        throw err;
      }
    },

    async addPotentialPolicyFile({ commit }, { potentialPolicyId, files }) {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("potential_policy_files[]", file);
      });
      try {
        return await api({ requiresAuth: true }).post(
          `/v1/potential-policies/${potentialPolicyId}/files`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || "Something went wrong.",
        }, { root: true });
        throw err;
      }
    },

    async updatePotentialPolicy({ commit }, { policyId, ...policy }) {
      try {
        return await api({ requiresAuth: true }).patch(`/v1/potential-policies/${policyId}`, {
          ...policy,
        });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || "Something went wrong.",
        }, { root: true });
        throw err;
      }
    },
  },
};
